import script from "./BaseCarousel.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./BaseCarousel.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./BaseCarousel.vue?vue&type=style&index=0&id=7fb901b2&lang=scss"

const __exports__ = script;

export default __exports__